import memoize from 'transmute/memoize';
// @ts-expect-error Untyped dependency
import EmailAddressRegex from 'PatternValidationJS/patterns/EmailAddress';
// @ts-expect-error Untyped dependency
import DomainRegex from 'PatternValidationJS/patterns/Domain';

// Based on URI spec: https://www.rfc-editor.org/rfc/rfc3986#appendix-B
const DOMAIN_PROTOCOL_REGEX = /(^[^:/?#]*:(?:\/+)?)?(?:.*)/;
function isNotHubspotSupportEmail(email) {
  return !/(support\.hubspot\.com)/g.test(email);
}
export function isValidEmail(email) {
  return email && EmailAddressRegex.test(email) && isNotHubspotSupportEmail(email);
}
export const removeProtocolAndWwwPrefix = domain => {
  return domain.replace(/https?:\/\//i, '').replace(/(www\.)?/i, '');
};
export function domainContainsPath(domain) {
  const parsedDomain = removeProtocolAndWwwPrefix(domain);
  return parsedDomain.indexOf('/') !== -1;
}
function getDomainProtocol(domain) {
  // Cast OK due to (?:.*) capture group always matching
  const match = domain.match(DOMAIN_PROTOCOL_REGEX);
  return match[1];
}
export function domainContainsProtocol(domain) {
  return Boolean(domain && getDomainProtocol(domain) !== undefined);
}
export function getDomainProtocolInfo(domain) {
  if (!domain) {
    return {
      domain,
      protocol: undefined
    };
  }
  const protocol = getDomainProtocol(domain);
  if (protocol !== undefined) {
    return {
      domain: domain.replace(protocol, ''),
      protocol
    };
  }
  return {
    domain,
    protocol: undefined
  };
}
export function getDomainPathInfo(domain) {
  if (!domain) {
    return {
      domain,
      path: undefined
    };
  }
  const parsedDomain = removeProtocolAndWwwPrefix(domain);

  // We can cast this here because the regex will match anything, even an empty
  // string (.* will match blank)
  const match = parsedDomain.match(/([^/]*)(.*)/);
  if (!domainContainsPath(domain)) {
    return {
      domain: parsedDomain,
      path: undefined
    };
  }
  return {
    domain: match[1],
    path: match[2]
  };
}
export const getDomain = memoize(url => {
  if (!url) {
    return undefined;
  }
  const pathInfo = getDomainPathInfo(url);
  return pathInfo.domain;
});
export function isValidDomain(domain) {
  const {
    domain: parsedDomain
  } = getDomainPathInfo(domain);
  if (!parsedDomain) {
    return false;
  }
  return DomainRegex.test(parsedDomain);
}